import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorToolsZoomService {

  private zoomPlusListener = new Subject<any>();
  private zoomMinusListener = new Subject<any>();

  constructor() { }

  public listenZoomPlus() {
    return this.zoomPlusListener.asObservable();
  }

  public zoomPlus() {
    this.zoomPlusListener.next();
  }

  public listenZoomMinus() {
    return this.zoomMinusListener.asObservable();
  }

  public zoomMinus() {
    this.zoomMinusListener.next();
  }

}
